export default "__VITE_ASSET__hs92F9Af__"